import styled from "styled-components"

import tokens from "../_tokens"

const InlineCode = styled.code`
  padding: 0.2em 0.4em;
  font-family: ${tokens.font.mono};
  font-size: 85%;
  background-color: ${tokens.color.bgLight};
  border-radius: 3px;
`

export default InlineCode
